import React, { useContext } from 'react';
import { SidebarCollapseContext } from './SidebarCollapseContext';

export default function SidebarDivider() {
  const { collapsed } = useContext(SidebarCollapseContext);
  return (
    <li className="nav-item" style={{ marginBottom: collapsed ? '0.4rem' : '0.125rem' }}>
      <hr style={{ margin: '0.5rem 0.75rem', borderTopColor: '#e7eaf3', opacity: 1 }} />
    </li>
  );
}
